const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
       navigator.userAgent &&
       navigator.userAgent.indexOf('CriOS') === -1 &&
       navigator.userAgent.indexOf('FxiOS') === -1;

export const supports = {
    SCREENSHOT: !iOS && !isSafari,
    iOS
}